import type { MethodBaseOptions, StatamicEntryResponse } from '../types';
import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function getEntry(payload: { url: string }, options?: MethodBaseOptions) {

    const result = await (new AxiosRequestSender(client)
      .setUrl('entry')
      .setMethod('GET')
      .setProps({id: payload.url})
      .send<StatamicEntryResponse>());

    const statamicEntry = result.entry;

    const page = {
        component: "Page",
        name: statamicEntry.id,
        url: statamicEntry.slug,
        content: []
    };
    for (let statamicComponent of statamicEntry.components) {
        let {__typename: componentType, ...statamicComponentObject} = statamicComponent
        let component = {
            fields: {
                component: componentType,
                ...statamicComponentObject
            }
        }
        page.content.push(component);
    }

    return [{
        fields: page
    }];
}
